import type { StaticImageData } from "next/image";
import avatarNidhi from "@/app/assets/images/testimonials/avatar-nidhi.png";
import avatarMale from "@/app/assets/images/testimonials/avatar-male.png";

export type TestimonialItem = {
    quote: string;
    name: string;
    role: string;
    avatar: StaticImageData;
};

/**
 * Testimonials fold copy — Figma web 2745:21026 / mobile 2541:30640
 * Edit this list to refresh marquee / carousel cards.
 * Avatars: Nidhi — Figma 7508:115440; male — existing photo asset.
 */
export const TESTIMONIALS_NEW: TestimonialItem[] = [
    {
        quote: "These guys have a good track record, so it was a no-brainer for me to invest about 4 lakhs in their first issue. I'll also recommend to my family & friends to invest.",
        name: "Nidhi Agarwal",
        role: "Startup founder",
        avatar: avatarNidhi,
    },
    {
        quote: "All information required for me to invest has been laid out in a transparent manner. Webinar has helped me take an informed decision.",
        name: "Lakshminarayanan Iyer",
        role: "Investor",
        avatar: avatarMale,
    },
    {
        quote: "InCred Money is simple and easy to use. I can check my investments, explore different options and track my portfolio without spending too much time figuring things out.",
        name: "Shubham Vasudev",
        role: "InCred Money Customer",
        avatar: avatarMale,
    },
    {
        quote: "I like to understand things properly before investing. InCred Money gives me the information I need in an easy-to-understand way, so I can go through it at my own pace and decide.",
        name: "Dhruv Sheth",
        role: "Investor",
        avatar: avatarMale,
    },
    {
        quote: "I came across InCred Money while exploring new investment options. The platform was easy to navigate, the information was helpful and I could get support whenever I had a question.",
        name: "Atul Tupe",
        role: "Investor",
        avatar: avatarMale,
    },
    {
        quote: "Customer support is very important to me, especially when it comes to investments. Whenever I’ve reached out, the InCred Money team has been helpful and taken the time to answer my questions.",
        name: "Abhay Yadav",
        role: "Investor",
        avatar: avatarMale,
    },
    {
        quote: "I’ve used different investment platforms over the years. What I like about InCred Money is how straightforward it is to check my portfolio, explore options and manage my investments.",
        name: "Shilpa Nayar",
        role: "Investor",
        avatar: avatarNidhi,
    },
    {
        quote: "InCred Money is easy to follow, whether I’m checking an existing investment or exploring something new. Whenever I’ve needed help, the team has also been supportive.",
        name: "Govind Menon",
        role: "Investor",
        avatar: avatarMale,
    },
    {
        quote: "What I really appreciate is the support from the relationship team. Whenever I have a question, they take the time to explain things simply and never make me feel rushed.",
        name: "Disha Maniar",
        role: "Investor",
        avatar: avatarNidhi,
    },
];

export const TESTIMONIAL_STATS = [
    { value: "1.5L+", label: "INVESTORS" },
    { value: "10L+", label: "APP DOWNLOADS" },
] as const;
